var map = {
	"./2dmap/changeMap3D.png": "8gEv",
	"./2dmap_eyes/changeMap3D.png": "pb5N"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hVUI";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/changeMap3D\.png$
// module id = hVUI
// module chunks = 2